<template>
  <div>
    <a-card v-if="lockanList || enterpriseList" :bordered="false" style="position: relative;">
      <a-row style="margin-bottom: 20px">
        <a-col :span="10" :offset="14" style="text-align: right">
          <a-button type="primary" v-if="importEnabel">
            <a href="/师傅导入模板.xlsx" download="师傅导入模板.xlsx" style="text-decoration: none">下载导入模板</a>
          </a-button>
          <a-upload
            v-if="importEnabel"
            style="margin: 0 8px"
            name="file"
            :action="uploadUrl"
            @change="handleChange"
            :headers="headers"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :showUploadList="false"
          >
            <a-button type="primary">
              导入
            </a-button>
          </a-upload>
          <a-button v-if="exportEnable" type="primary" @click="FileExcel">导出Excel</a-button>
        </a-col>
      </a-row>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form" @keyup.enter="handleSelect">
          <div v-if="innerArchivesEnable && innerEnable">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-input v-model="queryParam.loginName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-input v-model="queryParam.userName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="queryParam.phonenumber" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅类型" style="margin-left: 18px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.workerType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-form-item
                    label="服务区域"
                    style="margin-left:24px;margin-right: 12px;"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="8">
                      <a-select v-decorator="['serviceProvinceId']" @change="haveProvince1">
                        <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                          type.provinceName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8">
                      <a-select v-decorator="['serviceCityId']" @change="haveProvince2">
                        <a-select-option :title="type.cityName" v-for="type in data2" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8">
                      <a-select v-decorator="['serviceDistrictId']">
                        <a-select-option :title="type.areaName" v-for="type in data3" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="服务类型" style="margin-left: 26px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.installType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes1" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅等级" style="margin-left: 18px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.techLevel">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes2" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-row :gutter="24">
                  <a-form-item
                    style="margin-left:24px;margin-right: 12px;"
                    label="师傅得分"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="11">
                      <a-input v-model="queryParam.userStartScore" />
                    </a-col>
                    <a-col :span="2" style="display: flex;justify-content: center">
                      -
                    </a-col>
                    <a-col :span="11">
                      <a-input v-model="queryParam.userEndScore" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="接单模式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-select v-model="queryParam.receiptType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes3" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left:54px">
                  <a-select v-model="queryParam.masterLabel">
                    <a-select-option :title="type.installLabelName" v-for="type in data" :key="type.installLabelId">{{
                      type.installLabelName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 18px;">
                  <a-select v-model="queryParam.forbiddenStatus">
                    <a-select-option :value="0">正常</a-select-option>
                    <a-select-option :value="1">禁用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-form-item
                    label="注册地址"
                    style="margin-left:24px;margin-right: 12px;"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="5">
                      <a-select v-decorator="['provinceId']" @change="haveProvince3">
                        <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                          type.provinceName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="5">
                      <a-select v-decorator="['cityId']" @change="haveProvince4">
                        <a-select-option :title="type.cityName" v-for="type in data4" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="5">
                      <a-select v-decorator="['districtId']" @change="haveProvince5">
                        <a-select-option :title="type.areaName" v-for="type in data5" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="9">
                      <a-input v-decorator="['detailedAddress']" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item style="margin-left: 24px;" label="注册情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.status">
                    <a-select-option title="未审核" value="0">
                      未审核
                    </a-select-option>
                    <a-select-option title="未通过" value="2">
                      未通过
                    </a-select-option>
                    <a-select-option title="已通过" value="1">
                      已通过
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="合同文件" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 18px;">
                  <a-select v-model="queryParam.hasContract">
                    <a-select-option value="0">
                      无
                    </a-select-option>
                    <a-select-option value="1">
                      有
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <div v-if="isShow == 1">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="提现周期" style="margin-left:12px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.cashCycle">
                      <a-select-option :title="type.label" v-for="type in restaurantTypes4" :key="type.code">{{
                        type.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="提现方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                    <a-select v-model="queryParam.cashStatus">
                      <a-select-option :title="type.label" v-for="type in restaurantTypes5" :key="type.code">{{
                        type.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-select v-model="queryParam.timeType1">
                    <a-select-option :title="type.label" v-for="type in options" :key="type.value">
                      {{ type.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-range-picker
                    v-model="queryParam1.tiem2"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="onChange1"
                    @ok="onOk"
                  />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item
                    style="margin-left: -2px;"
                    label="渠道负责人"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <!--<a-input v-model="queryParam.masterProvince"/>-->
                    <a-select v-model="queryParam.masterProvince">
                      <a-select-option :title="type.userName" v-for="type in pullDown" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!--<a-input v-model="queryParam.masterLeading"/>-->
                    <a-select v-model="queryParam.masterLeading">
                      <a-select-option :title="type.userName" v-for="type in pullDown" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-select v-model="queryParam.timeType2">
                    <a-select-option :title="type.label" v-for="type in options" :key="type.value">
                      {{ type.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam1.tiem1"
                    format="YYYY-MM-DD HH:mm:ss"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="onChange2"
                    @ok="onOk"
                  />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-row :gutter="24">
                    <a-form-item
                      label="保证金"
                      style="margin-left:36px;margin-right:12px"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <a-col :span="11">
                        <a-input v-model="queryParam.bondBegin" />
                      </a-col>
                      <a-col :span="2" style="display: flex;justify-content: center">
                        -
                      </a-col>
                      <a-col :span="11">
                        <a-input v-model="queryParam.bondEnd" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="区域置顶" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                    <a-select v-model="queryParam.isTop">
                      <a-select-option value="0">
                        不是
                      </a-select-option>
                      <a-select-option value="1">
                        是
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item style="margin-left: 54px;" label="私密" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.privateMaster">
                      <a-select-option value="0">
                        不是
                      </a-select-option>
                      <a-select-option value="1">
                        是
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-row :gutter="24">
                    <a-form-item
                      style="margin-right: 12px;"
                      label="近30天投诉率"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <a-col :span="11">
                        <a-input v-model="queryParam.complaintRateBegin" />
                      </a-col>
                      <a-col :span="2" style="display: flex;justify-content: center">
                        -
                      </a-col>
                      <a-col :span="11">
                        <a-input v-model="queryParam.complaintRateEnd" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
              </a-row>
            </div>
          </div>
          <di v-if="innerArchivesEnable && !innerEnable">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-input v-model="queryParam.loginName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-input v-model="queryParam.userName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="queryParam.phonenumber" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅类型" style="margin-left: 18px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.workerType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-form-item
                    label="服务区域"
                    style="margin-left:24px;margin-right: 12px;"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="8">
                      <a-select v-decorator="['serviceProvinceId']" @change="haveProvince1">
                        <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                          type.provinceName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8">
                      <a-select v-decorator="['serviceCityId']" @change="haveProvince2">
                        <a-select-option :title="type.cityName" v-for="type in data2" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8">
                      <a-select v-decorator="['serviceDistrictId']">
                        <a-select-option :title="type.areaName" v-for="type in data3" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="服务类型" style="margin-left: 26px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.installType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes1" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅等级" style="margin-left: 18px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.techLevel">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes2" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-row :gutter="24">
                  <a-form-item
                    style="margin-left:24px;margin-right: 12px;"
                    label="师傅得分"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="11">
                      <a-input v-model="queryParam.userStartScore" />
                    </a-col>
                    <a-col :span="2" style="display: flex;justify-content: center">
                      -
                    </a-col>
                    <a-col :span="11">
                      <a-input v-model="queryParam.userEndScore" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="接单模式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-select v-model="queryParam.receiptType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes3" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item style="margin-left: 54px;" label="私密" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.privateMaster">
                    <a-select-option value="0">
                      不是
                    </a-select-option>
                    <a-select-option value="1">
                      是
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 18px;">
                  <a-select v-model="queryParam.forbiddenStatus">
                    <a-select-option :value="0">正常</a-select-option>
                    <a-select-option :value="1">禁用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-form-item
                    label="注册地址"
                    style="margin-left:24px;margin-right: 12px;"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="5">
                      <a-select v-decorator="['provinceId']" @change="haveProvince3">
                        <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                          type.provinceName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="5">
                      <a-select v-decorator="['cityId']" @change="haveProvince4">
                        <a-select-option :title="type.cityName" v-for="type in data4" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="5">
                      <a-select v-decorator="['districtId']" @change="haveProvince5">
                        <a-select-option :title="type.areaName" v-for="type in data5" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="9">
                      <a-input v-decorator="['detailedAddress']" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item style="margin-left: 24px;" label="注册情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.status">
                    <a-select-option title="未审核" value="0">
                      未审核
                    </a-select-option>
                    <a-select-option title="未通过" value="2">
                      未通过
                    </a-select-option>
                    <a-select-option title="已通过" value="1">
                      已通过
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="合同文件" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 18px;">
                  <a-select v-model="queryParam.hasContract">
                    <a-select-option value="0">
                      无
                    </a-select-option>
                    <a-select-option value="1">
                      有
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <div v-if="isShow == 1">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="提现周期" style="margin-left:12px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.cashCycle">
                      <a-select-option :title="type.label" v-for="type in restaurantTypes4" :key="type.code">{{
                        type.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="提现方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                    <a-select v-model="queryParam.cashStatus">
                      <a-select-option :title="type.label" v-for="type in restaurantTypes5" :key="type.code">{{
                        type.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-select v-model="queryParam.timeType1">
                    <a-select-option :title="type.label" v-for="type in options" :key="type.value">
                      {{ type.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-range-picker
                    v-model="queryParam1.tiem2"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="onChange1"
                    @ok="onOk"
                  />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item
                    style="margin-left: -2px;"
                    label="渠道负责人"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <!--<a-input v-model="queryParam.masterProvince"/>-->
                    <a-select v-model="queryParam.masterProvince">
                      <a-select-option :title="type.userName" v-for="type in pullDown" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!--<a-input v-model="queryParam.masterLeading"/>-->
                    <a-select v-model="queryParam.masterLeading">
                      <a-select-option :title="type.userName" v-for="type in pullDown" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-select v-model="queryParam.timeType2">
                    <a-select-option :title="type.label" v-for="type in options" :key="type.value">
                      {{ type.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam1.tiem1"
                    format="YYYY-MM-DD HH:mm:ss"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="onChange2"
                    @ok="onOk"
                  />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-row :gutter="24">
                    <a-form-item
                      label="保证金"
                      style="margin-left:36px;margin-right:12px"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <a-col :span="11">
                        <a-input v-model="queryParam.bondBegin" />
                      </a-col>
                      <a-col :span="2" style="display: flex;justify-content: center">
                        -
                      </a-col>
                      <a-col :span="11">
                        <a-input v-model="queryParam.bondEnd" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="区域置顶" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                    <a-select v-model="queryParam.isTop">
                      <a-select-option value="0">
                        不是
                      </a-select-option>
                      <a-select-option value="1">
                        是
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-row :gutter="24">
                    <a-form-item
                      style="margin-right: 12px;"
                      label="近30天投诉率"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <a-col :span="11">
                        <a-input v-model="queryParam.complaintRateBegin" />
                      </a-col>
                      <a-col :span="2" style="display: flex;justify-content: center">
                        -
                      </a-col>
                      <a-col :span="11">
                        <a-input v-model="queryParam.complaintRateEnd" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
              </a-row>
            </div>
          </di>
          <div v-if="!innerArchivesEnable && innerEnable">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-input v-model="queryParam.loginName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-input v-model="queryParam.userName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="queryParam.phonenumber" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅类型" style="margin-left: 18px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.workerType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-form-item
                    label="服务区域"
                    style="margin-left:24px;margin-right: 12px;"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="8">
                      <a-select v-decorator="['serviceProvinceId']" @change="haveProvince1">
                        <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                          type.provinceName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8">
                      <a-select v-decorator="['serviceCityId']" @change="haveProvince2">
                        <a-select-option :title="type.cityName" v-for="type in data2" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8">
                      <a-select v-decorator="['serviceDistrictId']">
                        <a-select-option :title="type.areaName" v-for="type in data3" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="服务类型" style="margin-left: 26px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.installType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes1" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="区域置顶" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-select v-model="queryParam.isTop">
                    <a-select-option value="0">
                      不是
                    </a-select-option>
                    <a-select-option value="1">
                      是
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-row :gutter="24">
                  <a-form-item
                    style="margin-left:24px;margin-right: 12px;"
                    label="师傅得分"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="11">
                      <a-input v-model="queryParam.userStartScore" />
                    </a-col>
                    <a-col :span="2" style="display: flex;justify-content: center">
                      -
                    </a-col>
                    <a-col :span="11">
                      <a-input v-model="queryParam.userEndScore" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="接单模式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-select v-model="queryParam.receiptType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes3" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left:54px">
                  <a-select v-model="queryParam.masterLabel">
                    <a-select-option :title="type.installLabelName" v-for="type in data" :key="type.installLabelId">{{
                      type.installLabelName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 18px;">
                  <a-select v-model="queryParam.forbiddenStatus">
                    <a-select-option :value="0">正常</a-select-option>
                    <a-select-option :value="1">禁用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-form-item
                    label="注册地址"
                    style="margin-left:24px;margin-right: 12px;"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="5">
                      <a-select v-decorator="['provinceId']" @change="haveProvince3">
                        <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                          type.provinceName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="5">
                      <a-select v-decorator="['cityId']" @change="haveProvince4">
                        <a-select-option :title="type.cityName" v-for="type in data4" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="5">
                      <a-select v-decorator="['districtId']" @change="haveProvince5">
                        <a-select-option :title="type.areaName" v-for="type in data5" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="9">
                      <a-input v-decorator="['detailedAddress']" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item style="margin-left: 24px;" label="注册情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.status">
                    <a-select-option title="未审核" value="0">
                      未审核
                    </a-select-option>
                    <a-select-option title="未通过" value="2">
                      未通过
                    </a-select-option>
                    <a-select-option title="已通过" value="1">
                      已通过
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="合同文件" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 18px;">
                  <a-select v-model="queryParam.hasContract">
                    <a-select-option value="0">
                      无
                    </a-select-option>
                    <a-select-option value="1">
                      有
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <div v-if="isShow == 1">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="提现周期" style="margin-left:12px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.cashCycle">
                      <a-select-option :title="type.label" v-for="type in restaurantTypes4" :key="type.code">{{
                        type.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="提现方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                    <a-select v-model="queryParam.cashStatus">
                      <a-select-option :title="type.label" v-for="type in restaurantTypes5" :key="type.code">{{
                        type.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-select v-model="queryParam.timeType1">
                    <a-select-option :title="type.label" v-for="type in options" :key="type.value">
                      {{ type.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-range-picker
                    v-model="queryParam1.tiem2"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="onChange1"
                    @ok="onOk"
                  />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item
                    style="margin-left: -2px;"
                    label="渠道负责人"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <!--<a-input v-model="queryParam.masterProvince"/>-->
                    <a-select v-model="queryParam.masterProvince">
                      <a-select-option :title="type.userName" v-for="type in pullDown" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!--<a-input v-model="queryParam.masterLeading"/>-->
                    <a-select v-model="queryParam.masterLeading">
                      <a-select-option :title="type.userName" v-for="type in pullDown" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-select v-model="queryParam.timeType2">
                    <a-select-option :title="type.label" v-for="type in options" :key="type.value">
                      {{ type.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam1.tiem1"
                    format="YYYY-MM-DD HH:mm:ss"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="onChange2"
                    @ok="onOk"
                  />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-row :gutter="24">
                    <a-form-item
                      label="保证金"
                      style="margin-left:36px;margin-right:12px"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <a-col :span="11">
                        <a-input v-model="queryParam.bondBegin" />
                      </a-col>
                      <a-col :span="2" style="display: flex;justify-content: center">
                        -
                      </a-col>
                      <a-col :span="11">
                        <a-input v-model="queryParam.bondEnd" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
                <a-col :span="6">
                  <a-row :gutter="24">
                    <a-form-item
                      style="margin-right: 12px;"
                      label="近30天投诉率"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <a-col :span="11">
                        <a-input v-model="queryParam.complaintRateBegin" />
                      </a-col>
                      <a-col :span="2" style="display: flex;justify-content: center">
                        -
                      </a-col>
                      <a-col :span="11">
                        <a-input v-model="queryParam.complaintRateEnd" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
              </a-row>
            </div>
          </div>
          <div v-if="!innerArchivesEnable && !innerEnable">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-input v-model="queryParam.loginName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-input v-model="queryParam.userName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="queryParam.phonenumber" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅类型" style="margin-left: 18px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.workerType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-form-item
                    label="服务区域"
                    style="margin-left:24px;margin-right: 12px;"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="8">
                      <a-select v-decorator="['serviceProvinceId']" @change="haveProvince1">
                        <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                          type.provinceName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8">
                      <a-select v-decorator="['serviceCityId']" @change="haveProvince2">
                        <a-select-option :title="type.cityName" v-for="type in data2" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8">
                      <a-select v-decorator="['serviceDistrictId']">
                        <a-select-option :title="type.areaName" v-for="type in data3" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="服务类型" style="margin-left: 26px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.installType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes1" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="区域置顶" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-select v-model="queryParam.isTop">
                    <a-select-option value="0">
                      不是
                    </a-select-option>
                    <a-select-option value="1">
                      是
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-row :gutter="24">
                  <a-form-item
                    style="margin-left:24px;margin-right: 12px;"
                    label="师傅得分"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="11">
                      <a-input v-model="queryParam.userStartScore" />
                    </a-col>
                    <a-col :span="2" style="display: flex;justify-content: center">
                      -
                    </a-col>
                    <a-col :span="11">
                      <a-input v-model="queryParam.userEndScore" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="接单模式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <a-select v-model="queryParam.receiptType">
                    <a-select-option :title="type.label" v-for="type in restaurantTypes3" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 18px;">
                  <a-select v-model="queryParam.forbiddenStatus">
                    <a-select-option :value="0">正常</a-select-option>
                    <a-select-option :value="1">禁用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-row :gutter="24">
                  <a-form-item
                    label="保证金"
                    style="margin-left:36px;margin-right:12px"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="11">
                      <a-input v-model="queryParam.bondBegin" />
                    </a-col>
                    <a-col :span="2" style="display: flex;justify-content: center">
                      -
                    </a-col>
                    <a-col :span="11">
                      <a-input v-model="queryParam.bondEnd" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-form-item
                    label="注册地址"
                    style="margin-left:24px;margin-right: 12px;"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-col :span="5">
                      <a-select v-decorator="['provinceId']" @change="haveProvince3">
                        <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                          type.provinceName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="5">
                      <a-select v-decorator="['cityId']" @change="haveProvince4">
                        <a-select-option :title="type.cityName" v-for="type in data4" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="5">
                      <a-select v-decorator="['districtId']" @change="haveProvince5">
                        <a-select-option :title="type.areaName" v-for="type in data5" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="9">
                      <a-input v-decorator="['detailedAddress']" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item style="margin-left: 24px;" label="注册情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.status">
                    <a-select-option title="未审核" value="0">
                      未审核
                    </a-select-option>
                    <a-select-option title="未通过" value="2">
                      未通过
                    </a-select-option>
                    <a-select-option title="已通过" value="1">
                      已通过
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="合同文件" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 18px;">
                  <a-select v-model="queryParam.hasContract">
                    <a-select-option value="0">
                      无
                    </a-select-option>
                    <a-select-option value="1">
                      有
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <div v-if="isShow == 1">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="提现周期" style="margin-left:12px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.cashCycle">
                      <a-select-option :title="type.label" v-for="type in restaurantTypes4" :key="type.code">{{
                        type.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="提现方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                    <a-select v-model="queryParam.cashStatus">
                      <a-select-option :title="type.label" v-for="type in restaurantTypes5" :key="type.code">{{
                        type.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-select v-model="queryParam.timeType1">
                    <a-select-option :title="type.label" v-for="type in options" :key="type.value">
                      {{ type.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-range-picker
                    v-model="queryParam1.tiem2"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="onChange1"
                    @ok="onOk"
                  />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item
                    style="margin-left: -2px;"
                    label="渠道负责人"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <!--<a-input v-model="queryParam.masterProvince"/>-->
                    <a-select v-model="queryParam.masterProvince">
                      <a-select-option :title="type.userName" v-for="type in pullDown" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!--<a-input v-model="queryParam.masterLeading"/>-->
                    <a-select v-model="queryParam.masterLeading">
                      <a-select-option :title="type.userName" v-for="type in pullDown" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-select v-model="queryParam.timeType2">
                    <a-select-option :title="type.label" v-for="type in options" :key="type.value">
                      {{ type.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam1.tiem1"
                    format="YYYY-MM-DD HH:mm:ss"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="onChange2"
                    @ok="onOk"
                  />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-row :gutter="24">
                    <a-form-item
                      style="margin-right: 12px;"
                      label="近30天投诉率"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <a-col :span="11">
                        <a-input v-model="queryParam.complaintRateBegin" />
                      </a-col>
                      <a-col :span="2" style="display: flex;justify-content: center">
                        -
                      </a-col>
                      <a-col :span="11">
                        <a-input v-model="queryParam.complaintRateEnd" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
              </a-row>
            </div>
          </div>
          <a-row>
            <a-col :span="3" :offset="12">
              <span v-if="isShow == 0" style="cursor:pointer" @click="getMore"
                ><a-icon type="down-circle" theme="twoTone" style="fontSize:24px"
              /></span>
              <span v-if="isShow == 1" style="cursor:pointer" @click="hiddenMore"
                ><a-icon type="up-circle" theme="twoTone" style="fontSize:24px"
              /></span>
            </a-col>
            <a-col :span="4" :offset="5" style="text-align: right">
              <a-button type="primary" htmlType="submit" @click="handleSelect">查询</a-button>
              <a-button style="margin-left: 8px" @click="handleClear">清空</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-divider />
      <!--<div class="table-operator">-->
      <a-row>
        <a-col :span="4" :offset="20" style="text-align: right">
          <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
          <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
          <!--<a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>-->
          <!--</a-dropdown>-->
        </a-col>
      </a-row>
      <!--</div>-->
      <a-table
        size="default"
        ref="table"
        rowKey="modelId"
        :loading="loading"
        :columns="columns"
        :dataSource="loadData"
        :scroll="{ x: 4500 }"
        style="margin-top: 20px"
        :pagination="false"
        bordered
      >
        <span slot="installType" slot-scope="text, record">
          <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">
            {{ type.label }}
          </td>
        </span>
        <span slot="forbiddenStatus" slot-scope="text, record">
          {{ render(text) }}
        </span>
        <span slot="userName" slot-scope="text, record">
          <span class="hover">{{ text }} </span>
          <a title="复制"><a-icon type="copy" class="copy" @click="Copys(record)"/></a>
        </span>
        <span slot="action" slot-scope="text, record" style="white-space: nowrap">
          <a @click="handlexamine(record)">详情</a>
          <a-divider v-if="editEnable && record.status == '已通过'" type="vertical" />
          <a v-if="editEnable && record.status == '已通过'" @click="handleEdit(record)">编辑</a>
          <a-divider v-if="areaEnable" type="vertical" />
          <a v-if="areaEnable" @click="handleCoverage(record)">服务区域</a>
          <span v-if="forbiddenEnable">
            <a-divider type="vertical" />
            <a v-if="record.forbiddenStatus == 1" @click="showState(record.userId, record.forbiddenStatus)">启用</a>
            <a v-else @click="showState(record.userId, record.forbiddenStatus)">禁用</a>
            <a-divider type="vertical" v-if="record.status == '已通过'" />
            <a v-if="record.status == '已通过'" @click="handleDeploy(record)">黑名单</a>
            <a-divider type="vertical" />
            <a @click="openOrder(record)">{{ record.orderReceiveStatus == '不可接单' ? '开启接单' : '禁止接单' }}</a>
          </span>
        </span>
      </a-table>
      <a-pagination
        showQuickJumper="true"
        showSizeChanger
        :pageSizeOptions="pageSizeOptions"
        :pageSize.sync="pageSize"
        @showSizeChange="onShowSizeChange"
        :total="total"
        v-model="current"
        @change="getdataList1"
        :showTotal="total => `总共 ${total} 条`"
        style="text-align: right;margin-top: 20px"
      />
      <masterlist-modal ref="modal" @ok="handleOk"></masterlist-modal>
      <masterlist-edit ref="modal2" @ok="handleOk"></masterlist-edit>
      <a-modal
        title="黑名单"
        style="top: 20px;"
        :width="800"
        v-model="visible"
        :confirmLoading="confirmLoading"
        @cancel="handleClose"
        @ok="handleSubmit"
      >
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item>
            你确定将此数据纳入黑名单吗？请注明原因：
          </a-form-item>
          <a-form-item label="">
            <a-textarea
              v-decorator="['reason', { rules: [{ required: true, message: '请输入纳入黑名单的原因' }] }]"
              :rows="4"
            />
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal
        title="导入失败文件"
        style="top: 20px;"
        v-model="bisible"
        @ok="handleSubmit2"
        :closable="false"
        :maskClosable="false"
      >
        <div style="margin-left: 50px">
          <p>
            <strong>导入成功数量 : </strong>
            <span>{{ success }}</span>
          </p>
          <p>
            <strong>导入失败数量 : </strong>
            <sapn style="color: red">{{ err }}</sapn>
          </p>
          <strong v-if="err == 0">全部导入成功！</strong>
          <strong v-else>是否下载导入失败文件？</strong>
        </div>
      </a-modal>
    </a-card>
    <no-authority v-if="!lockanList && !enterpriseList"></no-authority>
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  findByDeptId,
  selectFindAll,
  downloadErrorMaster,
  exportMaster,
  getSelectAllProvince,
  getelectCityName,
  getelectAreaName,
  forbiddenMaster,
  enableMaster,
  queryMaster,
  selectALLInstallLabel,
  addMaster,
  blackMaster,
  openOrder
} from '@/api/master/MasterList'
import MasterlistModal from './modules/MasterlistModal.vue'
import MasterlistEdit from './modules/MasterlistEdit.vue'
import NoAuthority from '../enterprise/NoAuthority'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'

const options = [
  { label: '注册时间', value: 'createTime' },
  { label: '审核时间', value: 'auditTime' },
  { label: '合同起始时间', value: 'contractStartTime' },
  { label: '合同到期时间', value: 'contractEndTime' },
  { label: '保证金缴纳时间', value: 'bondTime' },
  { label: '接单时间', value: 'receiveTime' },
  { label: '销单时间', value: 'saleTime' }
]

export default {
  name: 'ModelList',
  components: {
    STable,
    MasterlistModal,
    MasterlistEdit,
    NoAuthority
  },
  data() {
    return {
      // 分页
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      total: 0,
      current: 1,
      pageSize: 10,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        timeBegin1: '',
        timeEnd1: '',
        timeBegin2: '',
        timeEnd2: ''
      },
      queryParam1: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          width: '65px',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '80px',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '姓名',
          dataIndex: 'userName',
          scopedSlots: { customRender: 'userName' },
          align: 'center'
        },
        {
          title: '性别',
          dataIndex: 'sexName',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'phonenumber',
          align: 'center'
        },
        {
          title: '标签',
          dataIndex: 'masterLabelName',
          align: 'center'
        },
        {
          title: '接单状态',
          dataIndex: 'orderReceiveStatus',
          align: 'center'
        },
        {
          title: '师傅类型',
          dataIndex: 'workerTypeName',
          align: 'center'
        },
        {
          title: '师傅状态',
          dataIndex: 'forbiddenStatus',
          scopedSlots: { customRender: 'forbiddenStatus' },
          align: 'center'
        },
        {
          title: '得分',
          dataIndex: 'userScore',
          align: 'center'
        },
        {
          title: '师傅等级',
          dataIndex: 'techLevelName',
          align: 'center'
        },
        {
          title: '服务类型',
          dataIndex: 'installName',
          align: 'center'
        },
        {
          title: '省',
          dataIndex: 'provinceName',
          align: 'center'
        },
        {
          title: '市',
          dataIndex: 'cityName',
          align: 'center'
        },
        {
          title: '区',
          dataIndex: 'districtName',
          align: 'center'
        },
        {
          title: '街道',
          dataIndex: 'detailedAddress'
        },
        {
          title: '接单方式',
          dataIndex: 'receiptTypeName',
          align: 'center'
        },
        {
          title: '提现周期',
          dataIndex: 'cashCycleName',
          align: 'center'
        },
        {
          title: '提现方式',
          dataIndex: 'cashStatusName',
          align: 'center'
        },
        {
          title: '接单量',
          dataIndex: 'receiveOrder',
          align: 'center'
        },
        {
          title: '销单量',
          dataIndex: 'writeOrder',
          align: 'center'
        },
        {
          title: '近30天投诉率',
          dataIndex: 'complaintRateRecent',
          align: 'center'
        },
        {
          title: '已结算',
          dataIndex: 'completePrice',
          align: 'center'
        },
        {
          title: '待结算',
          dataIndex: 'pendingPrice',
          align: 'center'
        },
        // {
        //   title: '可提现金额',
        //   dataIndex: 'cashPrice',
        //   align:'center'
        // },
        {
          title: '保证金',
          dataIndex: 'bond',
          align: 'center'
        },
        {
          title: '缴纳时间',
          dataIndex: 'bondTime',
          align: 'center'
        },
        {
          title: '合同文件',
          dataIndex: 'hasContract',
          align: 'center'
        },
        {
          title: '合同有效期',
          dataIndex: 'contractDuration',
          align: 'center'
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterLeadingName',
          align: 'center'
        },
        {
          title: '渠道负责人',
          dataIndex: 'masterProvinceName',
          align: 'center'
        },
        {
          title: '审核时间',
          dataIndex: 'auditTime',
          align: 'center'
        },
        {
          title: '审核人',
          dataIndex: 'auditByName',
          align: 'center'
        },
        {
          title: '注册情况',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '注册人',
          dataIndex: 'createByName',
          align: 'center'
        }
      ],
      options, //检索下拉
      loadData: [],
      confirmLoading: false,
      // 上传
      fileList: [],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/master/master/importMaster',
      pagination: false,
      loading: false,
      visible: false,
      bisible: false,
      record: '',
      textArea: '',
      isShow: 0, // 显示、隐藏
      copyData: '', // 复制
      success: '',
      err: '',
      arrList: '',
      pullDown: '', //师傅负责人、渠道负责人
      restaurantTypes: [],
      restaurantTypes1: [],
      restaurantTypes2: [],
      restaurantTypes3: [],
      restaurantTypes4: [],
      restaurantTypes5: [],
      restaurantTypes6: [],
      data: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      addEnable: checkPermission('master:masterList:add'),
      importEnabel: checkPermission('master:masterList:import'),
      exportEnable: checkPermission('master:masterList:export'),
      forbiddenEnable: checkPermission('master:masterList:forbiddenAndBlacklist'),
      areaEnable: checkPermission('master:list:area:query'),
      editEnable: checkPermission('master:list:info:base:edit'),
      innerEnable: checkPermission('master:list:info:base:inner'),
      innerArchivesEnable: checkPermission('master:list:info:archives:inner'),
      lockanList: checkPermission('master:list:query:list:lockan'),
      enterpriseList: checkPermission('master:list:query:list:enterprise')
    }
  },
  filters: {},
  async created() {
    //回车键 查询数据
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.handleSelect()
    //   }
    // })
    // 师傅负责人
    findByDeptId().then(res => {
      // console.log(res)
      this.pullDown = res
    })
    selectFindAll({
      dictTypes: 'worker_type,install_type,tech_level,receipt_type,cash_cycle,cash_status,sys_user_sex'
    }).then(res => {
      // console.log(res)
      this.restaurantTypes = []
      this.restaurantTypes1 = []
      this.restaurantTypes2 = []
      this.restaurantTypes3 = []
      this.restaurantTypes4 = []
      this.restaurantTypes5 = []
      this.restaurantTypes6 = []
      this.restaurantOperTypeMap = res.worker_type
      this.restaurantOperTypeMap1 = res.install_type
      this.restaurantOperTypeMap2 = res.tech_level
      this.restaurantOperTypeMap3 = res.receipt_type
      this.restaurantOperTypeMap4 = res.cash_cycle
      this.restaurantOperTypeMap5 = res.cash_status
      this.restaurantOperTypeMap6 = res.sys_user_sex
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.restaurantTypes.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap2.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes2.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap3.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes3.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap4.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes4.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap5.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes5.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap6.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes6.push({ code: value.dictValue, label: value.dictLabel })
      })
      // console.log('ssas',this.restaurantTypes,this.restaurantTypes1,this.restaurantTypes2,this.restaurantTypes3,this.restaurantTypes4,this.restaurantTypes5,this.restaurantTypes6)
    })
    this.handleSelect()
    // 标签
    selectALLInstallLabel().then(res => {
      // console.log(res.data)
      this.data = res.data
    })
    // 省
    getSelectAllProvince().then(res => {
      // console.log(res)
      this.data1 = res.rows
    })
    for (let k in this.columns) {
      // console.log(this.columns[k]) //派单置顶、平台使用情况、标签
      if (!this.innerEnable) {
        if (this.columns[k].title == '标签') {
          this.columns.splice(k, 1)
        }
      }
      if (!this.innerArchivesEnable) {
        //[私密、师傅等级、师傅备注、备注
        if (this.columns[k].title == '师傅等级') {
          this.columns.splice(k, 1)
        }
      }
    }
  },
  // destroyed () { //回车键 查询数据
  //   document.body.removeEventListener('keyup', e => {})
  // },
  methods: {
    // 控制师傅是否可接单
    openOrder(record) {
      openOrder({
        userId: record.userId,
        receiveStatus: record.orderReceiveStatus == '不可接单' ? 1 : 0
      })
        .then(res => {
          if (res.code === 0) {
            this.$message.success('设置成功')
            this.handloadData()
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    moment,
    render(text) {
      return text == 0 ? '正常' : '禁用'
    },
    // 导出
    FileExcel() {
      var str = process.env.VUE_APP_API_BASE_URL + '/master/master/exportMaster?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
      // exportMaster(this.queryParam).then(res=>{
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = '师傅列表'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    handloadData() {
      queryMaster(this.queryParam).then(res => {
        // console.log('shifu',res)
        for (let i = 0; i < res.rows.length; i++) {
          for (let j = 0; j < this.restaurantTypes.length; j++) {
            if (this.restaurantTypes[j].code == res.rows[i].workerTypeName) {
              res.rows[i].workerTypeName = this.restaurantTypes[j].label

              break
            }
          }
          for (let j = 0; j < this.restaurantTypes5.length; j++) {
            if (this.restaurantTypes5[j].code == res.rows[i].cashStatusName) {
              res.rows[i].cashStatusName = this.restaurantTypes5[j].label
              break
            }
          }
          for (let j = 0; j < this.restaurantTypes2.length; j++) {
            if (this.restaurantTypes2[j].code == res.rows[i].techLevelName) {
              res.rows[i].techLevelName = this.restaurantTypes2[j].label
              break
            }
          }
          for (let j = 0; j < this.restaurantTypes6.length; j++) {
            if (this.restaurantTypes6[j].code == res.rows[i].sexName) {
              res.rows[i].sexName = this.restaurantTypes6[j].label
              break
            }
          }
          for (let j = 0; j < this.restaurantTypes4.length; j++) {
            if (this.restaurantTypes4[j].code == res.rows[i].cashCycleName) {
              res.rows[i].cashCycleName = this.restaurantTypes4[j].label
              break
            }
          }
        }
        this.loadData = res.rows
        this.total = res.total
      })
    },
    // 分页
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.handleSelect(current)
    },
    getdataList1(value) {
      this.queryParam.pageNum = value ? value : '1'
      this.queryParam.pageSize = this.pageSize
      this.handloadData()
    },
    handleSelect() {
      this.current = 1
      this.queryParam.cityId = this.form.getFieldValue('cityId')
      this.queryParam.districtId = this.form.getFieldValue('districtId')
      this.queryParam.provinceId = this.form.getFieldValue('provinceId')
      this.queryParam.detailedAddress = this.form.getFieldValue('detailedAddress')
      this.queryParam.serviceCityId = this.form.getFieldValue('serviceCityId')
      this.queryParam.serviceDistrictId = this.form.getFieldValue('serviceDistrictId')
      this.queryParam.serviceProvinceId = this.form.getFieldValue('serviceProvinceId')
      this.getdataList1()
    },
    handleClear() {
      this.form.resetFields()
      this.data2 = []
      this.data3 = []
      this.data4 = []
      this.data5 = []
      this.queryParam = {}
      this.queryParam1 = {}
    },
    // 更多、隐藏
    getMore() {
      this.isShow = 1
    },
    hiddenMore() {
      this.isShow = 0
    },
    handlexamine(record) {
      this.$refs.modal2.edit(record, '1', 0)
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    handleEdit(record) {
      this.$refs.modal2.edit(record, '1', 1, true)
    },
    // 复制
    Copys(val) {
      // console.log(val,'点击复制')
      this.copyData = '师傅姓名:' + val.userName + '\n' + '联系方式:' + val.phonenumber
      console.log(this.copyData)
      this.handcopy(this.copyData)
    },
    handcopy(data) {
      let url = data
      console.log(url)
      let oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      // console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    // 服务区域
    handleCoverage(record) {
      this.$refs.modal2.handleCoverage(record)
    },
    handleOk(value) {
      console.log(value)
      if (value == 1) {
        // this.$refs.table.refresh(true)
        this.getdataList1(1)
        this.current = 1
      } else {
        // this.$refs.table.refresh()
        this.getdataList1(this.current)
      }
    },
    onChange1(value, dateString) {
      // console.log('Selected Time1: ', value);
      // console.log('Formatted Selected Time1: ', dateString);
      this.queryParam.timeBegin1 = dateString[0]
      this.queryParam.timeEnd1 = dateString[1]
    },
    onChange2(value, dateString) {
      // console.log('Selected Time2: ', value);
      // console.log('Formatted Selected Time2: ', dateString);
      this.queryParam.timeBegin2 = dateString[0]
      this.queryParam.timeEnd2 = dateString[1]
    },
    onOk(value) {
      console.log('onOk: ', value)
    },
    // 省市区下拉
    haveProvince1(e) {
      this.data2 = []
      this.data3 = []
      this.form.setFieldsValue({
        serviceCityId: undefined,
        serviceDistrictId: undefined
      })
      getelectCityName({ provinceCode: e }).then(res => {
        // console.log(res)
        this.data2 = res.rows
      })
    },
    haveProvince2(e) {
      this.data3 = []
      this.form.setFieldsValue({
        serviceDistrictId: undefined
      })
      getelectAreaName({ cityCode: e }).then(res => {
        this.data3 = res.rows
      })
    },
    haveProvince3(e) {
      this.data4 = []
      this.data5 = []
      this.queryParam.detailedAddress = ''
      this.form.setFieldsValue({ cityId: undefined, districtId: undefined, detailedAddress: '' })
      getelectCityName({ provinceCode: e }).then(res => {
        // console.log(res)
        this.data4 = res.rows
      })
    },
    haveProvince4(e) {
      this.data5 = []
      this.queryParam.detailedAddress = ''
      this.form.setFieldsValue({ districtId: undefined, detailedAddress: '' })
      getelectAreaName({ cityCode: e }).then(res => {
        // console.log(res)
        this.data5 = res.rows
      })
    },
    haveProvince5() {
      this.form.setFieldsValue({ detailedAddress: '' })
    },
    showState(userId, forbiddenStatus) {
      if (forbiddenStatus == 0) {
        forbiddenMaster({ userId: userId }).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (forbiddenStatus == 1) {
        enableMaster({ userId: userId }).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 拉黑
    handleDeploy(record) {
      // console.log(record)
      this.record = record
      this.visible = true
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          values.userId = this.record.userId
          this.confirmLoading = true
          blackMaster(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('拉黑成功')
                this.handleOk()
                this.visible = false
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    // 失败文件处理
    handleSubmit2() {
      if (this.err == 0) {
        this.bisible = false
      } else {
        downloadErrorMaster(this.arrList).then(res => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          const a = document.createElement('a')
          // 生成文件路径
          let href = window.URL.createObjectURL(blob)
          a.href = href
          let fileName = '导入失败师傅文件'
          // 文件名中有中文 则对文件名进行转码
          a.download = decodeURIComponent(fileName)
          // 利用a标签做下载
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(href)
        })
        this.bisible = false
      }
    },
    // 上传
    handleChange(info) {
      // console.log(info)
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
        // console.log(info.file.response.data)
        let file = info.file.response.data
        if (file.error > 0) {
          this.bisible = true
          this.success = file.success
          this.err = file.error
          this.arrList = file.errorList
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    }
    // delByIds (modelId) {
    // delModel({'modelId': modelId}).then(res => {
    //   if (res.code === 0) {
    //     this.$message.success('删除成功')
    //     this.handleOk()
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    //   // this.selectedRowKeys = []
    // })
    // },
  },
  watch: {
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  }
}
</script>
<style scoped>
/*.trebtn{
    width: 140px;
    color: white;
    background-color: #17A4E1;
    position: absolute;
    font-size: 15px;
    top: -90px;
    right: 100px;
  }*/
.trebtn {
  width: 140px;
  color: white;
  background-color: #17a4e1;
  font-size: 15px;
  top: -90px;
  right: 100px;
}

.treo {
  right: 548px;
}
.treth {
  right: 248px;
}
.tret {
  right: 380px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
